<template>
  <div id="email-action-buttons" class="flex-row align-items-center gap-sm">
    <div v-if="email.received">
      <dd-icon-button
          v-if="email.processed === 0"
          id="action-button-process"
          icon="mdi mdi-check"
          title="Verwerken"
          size="xl"
          class="actions-button"
          @click="processEmail(email)"
      />
      <dd-icon-button
          v-else
          id="action-button-unprocess"
          icon="mdi mdi-undo"
          title="Markeren als onverwerkt"
          size="xl"
          class="actions-button"
          @click="unprocessEmail(email)"
      />
    </div>
    <div>
      <dd-icon-button
          v-if="!email.customer_id"
          id="action-button-match"
          icon="mdi mdi-link-variant"
          title="Koppelen"
          size="xl"
          class="actions-button"
          @click="showMatchModal(email)"
      />
      <dd-icon-button
          v-else
          id="action-button-unmatch"
          icon="mdi mdi-link-variant-off"
          title="Ontkoppelen"
          size="xl"
          class="actions-button"
          type="danger"
          @click="unmatchEmail(email)"
      />
    </div>
    <dd-icon-button
        id="action-button-reply"
        icon="mdi mdi-reply"
        title="Beantwoorden"
        size="xl"
        class="actions-button"
        @click="replyEmail(email)"
    />
    <dd-icon-button
        id="action-button-forward"
        icon="mdi mdi-forward"
        title="Doorsturen"
        size="xl"
        class="actions-button"
        @click="forwardEmail(email)"
    />

    <dd-dropdown-button-list
        compact
        title="Acties"
        :options="actionOptions"
    ></dd-dropdown-button-list>

    <delete-modal
        :visible="deleteModalVisible"
        :email="email"
        :description="`Weet je zeker dat je de email (${email.name || ''}) wil verwijderen?`"
        @cancel="() => {deleteModalVisible = false}"
        @deleted="afterDelete"
    ></delete-modal>
  </div>
</template>

<script>
import EmailApi from '~/api/email.js'
import SendStateEnum from "../../enums/SendStateEnum";
import {mapActions, mapGetters} from "vuex";
import DeleteModal from "../dialog_modal/DeleteModal.vue";

export default {
  name: "ViewActions",
  components: {
    DeleteModal
  },
  props: {
    email: {
      type: Object,
      required: true
    }
  },
  data(){
    return {
      deleteModalVisible: false,
    }
  },
  computed: {
    ...mapGetters('email', [
      "isCustomerPage",
      "accountState"
    ]),
    canDeleteEmail() {
      return this.$store.state.permissions.delete_email === true;
    },
    actionOptions() {
      let actionOptions = [
        {title: 'Printen', click: () => this.printEmail(this.email)},
        {title: 'Downloaden', click: () => this.downloadEmail(this.email)},
        {title: 'Link kopiëren', click: () => this.copyLink(this.email)},
      ];

      if (this.canDeleteEmail) {
        actionOptions.push({title: 'Verwijderen', click: () => {this.deleteModalVisible = true}});
      }

      return actionOptions;
    }
  },
  methods:{
    ...mapActions('email', [
      "loadEmails",
      "loadUnprocessedEmailCount",
      "setSendState",
      "setMatchState",
      "showReplyOrForwardEmail",
      "showMatchEmail",
      "goBack"
    ]),
    async processEmail(e){
      this.email.processed = 1;
      await EmailApi.processEmail(e.id);
      this.loadUnprocessedEmailCount();
      this.loadEmails();
    },
    async unprocessEmail(e){
      this.email.processed = 0;
      await EmailApi.unprocessEmail(e.id);
      this.loadUnprocessedEmailCount();
      this.loadEmails();
    },
    async showMatchModal(){
      await this.showMatchEmail();
    },
    async unmatchEmail(e){
      this.$set(this.email, 'customer_id', undefined);
      await EmailApi.unmatchEmail(e.id);
      await this.loadEmails();
    },
    downloadEmail(email){
      this.navigator.navigatePath(`/email/${email.id}/download`, '_blank');
    },
    copyLink(email){
      navigator.clipboard.writeText(this.route('vue.dashboard.email.show', email.id));
      this.$notification['success']({
        description: 'Link is succesvol gekopieerd'
      })
    },
    printEmail(email){
      this.navigator.navigatePath(`/email/${email.id}/print`, '_blank');
    },
    afterDelete (){
      this.deleteModalVisible = false;
      this.goBack();
      this.loadEmails();
    },
    async replyEmail(){
      if (this.isCustomerPage){
        this.navigator.navigate('vue.customer.email.reply', this.$route.params);
      } else {
        await this.setSendState(SendStateEnum.REPLY);
        await this.showReplyOrForwardEmail();
      }
    },
    async forwardEmail(){
      if (this.isCustomerPage){
        this.navigator.navigate('vue.customer.email.forward', this.$route.params);
      } else {
        await this.setSendState(SendStateEnum.FORWARD);
        await this.showReplyOrForwardEmail();
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.actions-button{
  min-height: $spacing-lg !important;
  padding: 0;
}
</style>
